import envConfig from "./envConfig.json";

export const config = { ...envConfig };
